import '../../Assets/Styles/home.css';
import '../../Assets/Styles/order.css';
import React from "react";
import { useMediaQuery } from 'react-responsive'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {Link,useNavigate} from 'react-router-dom';

import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button'; 
import { Divider } from 'primereact/divider';
import { addLocale } from 'primereact/api';
import { ProgressSpinner } from 'primereact/progressspinner';


import { Panel } from 'primereact/panel';
import Box from '@mui/material/Box';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Grid from '@mui/material/Grid';

import moment from "moment";

// Load Actions
import * as AppActions from '../../Store/Actions/App';
import * as PartnerActions from '../../Store/Actions/Partner';

import HeaderView from '../../Components/Layout/Header';
 
// Load Componentes
import SideMenu from '../../Components/SideMenu';
import AlertView from '../../Components/AlertModal';


import {
	validarCNPJ,
	validarCPF,
	validarEmail,
	validarTelefone,
	validarNome,
	maskCNPJ,
	maskCPF,
	maskPhone
} from '../../Components/Utils';

import {
	Callto,
	Whatsapp,

} from '../../Components/Utils';

// export default function Reservation() {
const Users = (props) => {
	
// Set var from props
const {
	setDialog,
	dialog,
	retrieveCompanyPersonData,
	updateCompanyPersonUserPassword
} = props;


const isDesktopOrLaptop = useMediaQuery({
query: '(min-width: 1024px)'
})
const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' })
const isSpecialDesktop = useMediaQuery({ query: '(max-width: 1500px)' })
const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

const [stillConnected, setStillConnected] = React.useState(false);
const onStillConnectedChange = (e) => {
	if (e.checked)
		setStillConnected(true);
	else
		setStillConnected(false);
}  // end function
	
const [loading, setLoading] = React.useState(true); 
const [saving, setSaving] = React.useState(false); 

const [userData, setUserData] = React.useState(null);

const [personName, setPersonName] = React.useState('');
const [personDocument, setPersonDocument] = React.useState('');
const [personPhone, setPersonPhone] = React.useState('');
const [email, setEmail] = React.useState('');
const [profile, setProfile] = React.useState('Usuário');
const [status, setStatus] = React.useState('Ativo');


const [password, setPassword] = React.useState('');
const [newPassword, setNewPassword] = React.useState('');
const [newPasswordConfirm, setNewPasswordConfirm] = React.useState('');

// Alert control
const [alert, setAlert] = React.useState(false); 
const [alertTitle, setAlertTitle] = React.useState("Informações"); 
const [alertAction, setAlertAction] = React.useState(""); 
const [alertBody, setAlertBody] = React.useState("Conteúdo dinâmico"); 

 
 	// Suggested password panel
    const PasswordTip = (
        <>
            <Divider />
            <p className="mt-1" style={{fontSize:"0.9rem"}}>Sugestão de senha</p>
            <ul className="pl-2 ml-2 mt-0 line-height-3" style={{fontSize:"0.8rem"}}>
                <li>Ao menos 1 letra maiúscula</li>
				<li>Ao menos 1 letra minúscula</li>
                <li>Ao menos 1 número </li>
				<li>Ao menos 1 símbolo ! # $ % & * + - = ? @ </li>
                <li>De 6 a 12 caracteres</li>
            </ul>
        </>
    );
 
/* -------------------------------- */ 
/* Custom methods and options START */
/* -------------------------------- */

// Retrieve Profile Data
const retrieveItemsList = () => {
  props.retrieveCompanyPersonData({
    setData: (data) => {
      setPersonName(data.person?.completeName || '');
      setPersonDocument(maskCPF(data.person?.document || ''));
      setPersonPhone(maskPhone(data.person?.mobilePhoneNumber || ''));
      setEmail(data.user?.email || '');
      setStatus(data.person?.status === 1 ? 'Ativo' : 'Desabilitado');
      setProfile(data.person?.groupName || 'Usuário');
	  setLoading(false);
    },
    setError: (msg) => {
      setAlert(true);
      setAlertTitle('Erro ao carregar dados');
      setAlertBody(msg);
	  setLoading(false);
    }
  });
};

const handleSavePassword = () => {
  if (!password || !newPassword || !newPasswordConfirm) {
    setAlert(true);
    setAlertTitle('Atenção');
    setAlertBody('Preencha todos os campos de senha.');
    return;
  }

  if (newPassword !== newPasswordConfirm) {
    setAlert(true);
    setAlertTitle('Atenção');
    setAlertBody('A nova senha e a confirmação não coincidem.');
    return;
  }

  setSaving(true);
  updateCompanyPersonUserPassword(
    { currentPassword: password, newPassword },
    {
      setSuccess: () => {
        setAlert(true);
        setAlertTitle('Sucesso');
        setAlertBody('Senha atualizada com sucesso.');
        setPassword('');
        setNewPassword('');
        setNewPasswordConfirm('');
        setSaving(false);
      },
      setError: (msg) => {
        setAlert(true);
        setAlertTitle('Erro');
        setAlertBody(msg);
        setSaving(false);
      }
    }
  );
};
 
/* -------------------------------- */ 
/* Custom methods and options END */
/* -------------------------------- */
 
 
/* -------------------- */ 
/* Common methods START */
/* -------------------- */
// Run after mount component
React.useEffect(() => {


  // set scroll to top
  window.scrollTo(0, 1);
  
  // Load list
  retrieveItemsList();
      
  // Runs when UNMOUNT component
  return () => {
    
	// unmount...	
	
  };
  
}, []); // end useEffect 


// Set calendar locale
addLocale('br', {
	firstDayOfWeek: 1,
	dayNames: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'],
	dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
	dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
	monthNames: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'],
	monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
	today: 'Hoje',
	clear: 'Limpar'
});

// set Use of history for PUSH 
var navigate = useNavigate(); 

/* -------------------- */ 
/* Common methods END */
/* -------------------- */
 
  return (
	<>
	<div id="adminSection" style={{marginTop:"0"}} className={isTabletOrMobile ? "login__wrapper mobile" : "login__wrapper"} >
		<div style={{height:"auto"}} className={isTabletOrMobile ? "login__wrapper_form_wrapper mobile" : "login__wrapper_form_wrapper"}> 		

			<HeaderView isOnAdmin={true} />

			<div className={isTabletOrMobile ? "login__form_wrapper mobile" : "login__form_wrapper"} style={{alignItems:"flex-start",marginTop:"6rem"}}>
						
				<div style={{flex:1,display:"flex",flexDirection:isMobile ? "column" : "row",justifyContent:"center",alignItems:"flex-start",gap:"10px",padding:isMobile ? "10px" : "40px",marginTop:"40px",height:"auto",marginLeft:"auto",marginRight:"auto",width:"100%",border:"0px solid red"}}>
				
						{/* Admin Side Menu */}
						<SideMenu state="open" />
						
						{/* Admin Content */}
						<div style={{flex:1,height:"100%",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
						
							<div style={{height:isMobile ? "" : "64px",width:"100%",display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
							
								<div style={{textAlign:"left",flex:2,color: '#2E0249', fontFamily: 'Titillium Web', fontSize: '36px', fontStyle: 'normal', fontWeight: 400, lineHeight: '120%', letterSpacing: '3.6px',padding:"10px"}}>Perfil do seu usuário</div>
							
							</div>
							
							
							<div style={{flex:1,width:"100%",backgroundColor:"#FFF"}}>
							
								<div className="card" style={{minHeight:"66vh",zIndex: 8,position:"relative"}}>
			
									<Box
									  sx={{
										width: isMobile ? "100%" : "80%",
										padding:"30px"
									  }}
									>
										<div className="registerModalIntro"> <i>No momento só é possível atualizar a senha do usuário. <br /> Caso precise atualizar outra informação entre em contato via whatsapp.</i></div>	

										<Divider />
										  
										{loading &&
										<>
											<div className="flex-row justify-center align-items-center" style={{minHeight:"45vh",width:"100%",zIndex:"10",backgroundColor:"#FFF"}}>
												<div className="flex flex-column align-items-center">
													<ProgressSpinner style={{width:"50px",height:"50px"}} />
													<span style={{marginTop:"1rem",fontSize:"1.1rem",fontFamily:"Graphie"}}>Carregando dados...</span>
												</div>
											</div>
										</>
										}										

										{!loading &&
										<>
											<Panel header="Dados do usuário" style={{marginBottom:"20px"}}>

												<Grid container spacing={3} style={{marginTop:"-20px"}}>

											
												  <Grid item xs={12} sm={6}>
													<div className="tAlignL w100">
														<label className="w100" style={{display:"block",marginBottom:"0.5rem",textAlign:"left"}}>Nome completo</label>
														<InputText id="personName" autoComplete="new-password" disabled={true} value={personName} style={{width:"100%"}} />
													</div>		
												  </Grid>
												  
												<Grid item xs={12} sm={6} style={{display:"flex",flexDirection:"row",justifyContent:"flex-start",alignItems:"center"}}>
													<div className="tAlignL w100">
														<label className="w100" style={{display:"block",marginBottom:"0.5rem",textAlign:"left"}}>CPF</label>
														<InputText id="personDocument" autoComplete="new-password" disabled={true}  value={personDocument} className="w100" style={{borderTopRightRadius:0,borderBottomRightRadius:0}} />
														
													</div>
												 </Grid>												  
												  
												<Grid item xs={12} sm={6}>
													<div className="tAlignL w100">
														<label className="w100" style={{display:"block",marginBottom:"0.5rem",textAlign:"left"}}>E-mail</label>
														<InputText id="email" autoComplete="new-password" disabled={true} value={email} className="w100" />
														
													</div>		
												  </Grid>												  
												  
												  <Grid item xs={12} sm={6}>
													<div className="tAlignL w100">
														<label className="w100" style={{display:"block",marginBottom:"0.5rem",textAlign:"left"}}>Telefone Celular</label>
														<InputText id="personPhone" autoComplete="new-password"disabled={true} value={personPhone} className="w100" />
													</div>	
												  </Grid>

												<Grid item xs={12} sm={6}>
													<div className="tAlignL w100">
														<label className="w100" style={{display:"block",marginBottom:"0.5rem",textAlign:"left"}}>Grupo</label>
														<InputText id="email" autoComplete="new-password" disabled={true} value={profile} className="w100" />
													</div>		
												  </Grid>	
												  
												<Grid item xs={12} sm={6}>
													<div className="tAlignL w100">
														<label className="w100" style={{display:"block",marginBottom:"0.5rem",textAlign:"left"}}>Status</label>
														<InputText id="email" autoComplete="new-password" disabled={true} value={status} className="w100" />
													</div>		
												  </Grid>													  
												 
												</Grid>

											</Panel>											  
										  
											<Panel header="Dados de acesso">

												<Grid container spacing={3} style={{marginTop:"-20px"}}>
												  <Grid item xs={12} sm={6}>
													<div className="tAlignL w100">
														<label className="w100" style={{display:"block",marginBottom:"0.5rem",textAlign:"left"}}>E-mail (login)</label>
														<InputText id="email" autoComplete="new-password" disabled={true} value={email} onChange={(e) => setEmail(e.target.value)} style={{width:"100%"}} />
													</div>		
												  </Grid>
												  
												  <Grid item xs={12} sm={6}>
													<div className="tAlignL w100">
														<label className="w100" style={{display:"block",marginBottom:"0.5rem",textAlign:"left"}}>Telefone Celular</label>
														<InputText id="personPhone" autoComplete="new-password" disabled={true} value={personPhone} className="w100" />
													</div>	
												  </Grid>												  
												  
												  <Grid item xs={12} sm={12} style={{paddingTop:0,marginBottom:0}}>
												  <Divider align="center" style={{marginBottom:0}}>
													<div className="tAlignL w100">
														<p><strong>Para alterar a senha</strong>, digite a senha atual, a nova senha e confirme a nova senha.</p>
													</div>
												  </Divider>
												  </Grid>
												  
												  <Grid item xs={12} sm={6} style={{paddingTop:"20px"}}>
													<div className="tAlignL w100">
														<label className="w100" style={{display:"block",marginBottom:"0.5rem",textAlign:"left"}}>Senha Atual<span className="requiredField">*</span></label>
														<Password className="passwordField" inputId="password" autoComplete="new-password" disabled={saving ? true : false} toggleMask value={password} onChange={(e) => setPassword(e.target.value)} inputStyle={{width:"100%"}} style={{width:"100%"}} feedback={true} tooltip="Informe a sua senha atual" tooltipOptions={{ position: 'bottom',event: 'focus' }} />
													</div>	
												  </Grid>												  
												  <Grid item xs={12} sm={6} style={{paddingTop:"20px"}}>
													<div className="tAlignL w100">
														<label className="w100" style={{display:"block",marginBottom:"0.5rem",textAlign:"left"}}>Nova Senha <span className="requiredField">*</span></label>
														<Password className="passwordField" inputId="password" autoComplete="new-password" disabled={saving ? true : false} toggleMask value={newPassword} onChange={(e) => setNewPassword(e.target.value)}  style={{width:"100%"}} feedback={true} promptLabel="Escolha uma senha" weakLabel="Senha fraca" mediumLabel="Senha média" strongLabel="Senha forte" footer={PasswordTip} tooltip="A senha tem que ser no mínimo média" tooltipOptions={{ position: 'bottom',event: 'focus' }} />
													</div>	
												  </Grid>
												  <Grid item xs={12} sm={6}>
													<div className="tAlignL w100">
														<label className="w100" style={{display:"block",marginBottom:"0.5rem",textAlign:"left"}}>Confirme a nova senha <span className="requiredField">*</span></label>
														<Password className="passwordField" inputId="passwordConfirm" autoComplete="new-password" disabled={saving ? true : false} toggleMask value={newPasswordConfirm} onChange={(e) => setNewPasswordConfirm(e.target.value)}  style={{width:"100%"}} feedback={false}  />
													</div>	
												  </Grid>
												  <Grid item xs={12} sm={6} style={{textAlign:"left",paddingTop:"2.7rem"}}>
													<Button label="Atualizar senha" className="filledButton" icon="pi pi-check" loading={saving} onClick={handleSavePassword} />
												  </Grid>												  
												</Grid>

											</Panel>	
										</>										  
										} 

								<div className="modalFooterButtons" style={{marginTop:"20px",textAlign:"right"}}>

									{/*<div className="modalFooterButtonsRight">
										<Button label="Atualizar senha" className="filledButton" icon="pi pi-check" loading={saving} onClick={handleSavePassword} />
									</div>*/}
									
								</div>												
						
								<AlertView
									alert={alert}
									setAlert={setAlert}
									alertTitle={alertTitle}
									alertBody={alertBody}
									alertAction={alertAction}
									scrollBlock={true}				
								/>
								</Box>
								
									
								</div>							
							
							</div>
						
						</div>
						
				</div>
			
			</div> 
		</div>
		
	
		
    </div>
	
	</>
  );
    
}

const mapStateToProps = store => ({
  dialog:store.appReducer.dialog
 });
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions,...PartnerActions }, dispatch);

export default connect(
		mapStateToProps,
		mapDispatchToProps
	)(Users);	


